import React, { Component } from 'react'
import { connect } from 'react-redux'

// API
import * as API  from '../../../utils/api'

// Components
import ModalContainer from '../ModalContainer'
import FlashMessage from '../../Global/FlashMessage'

// Actions
import { hideModal } from '../../../actions/modal'
import { updateActiveProfile } from '../../../actions/activeProfile'
import { updateForm } from '../../../actions/onboarding'
import { updateUserState } from '../../../actions/user'

class StripePaymentConfirmationModal extends Component {

  state = {
    status: '',
    errorMessage: '',
  }

  handleStripePayment = () => {
    const {
      user,
      stripeToken,
      taxRate,
      address,
      coupon,
      numberOfSports,
      modalLocation,
      // Dashboard Only Prop
      activeProfile,
      // Onboarding Only Prop
      athleteUsername,
    } = this.props

    this.setState(state => ({
      ...state,
      status: 'submitting'
    }), () => {
      const coupon_id = (coupon && coupon.valid) ? coupon.id : null
      const coupon_type = (coupon && coupon.valid) ? (coupon.percent_off ? 'percent':'amount') : null
      // Determine submit method based on where the user
      // is submitting payment (onboarding or their dashboard)
      if (modalLocation === 'onboarding') {
        this.submitStripePaymentAndAddParticipations(user, stripeToken, address, taxRate, athleteUsername, numberOfSports, coupon_id, coupon_type)
      } else if (modalLocation === 'dashboard') {
        this.submitDashboardStripePayment(user, stripeToken, address, taxRate, activeProfile.username, numberOfSports, coupon_id, coupon_type)
      }

    })
  }

  // Onboarding Modal Functions
  submitStripePaymentAndAddParticipations(user, token, address, taxRate, id, sportQuantity, coupon_id, coupon_type) {
    // Submit Payment to Stripe
    API.submitStripePayment(user, token, address, taxRate, id, sportQuantity, coupon_id, coupon_type)
    .then((response) => {
      if (response.errors) {
        this.setState({
          status: '',
          errorMessage: response.errors[0]
        })
      } else {
        // Add Participations to Profile
        const { username } = this.props.onboarding.maintained_profile
        const { participations } = this.props.onboarding

        API.addParticipations(user, username, participations).then(response => {
          if (response.errors) {
            this.setState({
              status: '',
              errorMessage: response.errors[0]
            })
          } else {
            let updatedUser = {
              ...this.props.user,
              paid_content: true
            }

            this.props.updateReduxUser(updatedUser)
            .then (() => {
              this.props.updateOnboardingForm({
                stripePaymentSuccessful: true
              })
            })
          }
        }) // End addParticipations()
      }
    }) // End submitStripePayment()
    .catch(error => {
      this.setState({
        status: '',
        errorMessage: error
      })
    })
  } // End submitStripePaymentAndAddParticipations()

  // Dashboard Modal Functions
  submitDashboardStripePayment(user, token, address, taxRate, id, sportQuantity, coupon_id, coupon_type) {
    API.submitStripePayment(user, token, address, taxRate, id, sportQuantity, coupon_id, coupon_type)
    .then((response) => {
      if (response.errors) {
        this.setState({
          status: '',
          errorMessage: response.errors[0]
        })
      } else {
        this.handleSuccessfulDashboardPaymentSubmit()
      }
    }) // End submitStripePayment()
  }

  handleSuccessfulDashboardPaymentSubmit() {
    const { activeProfile, user } = this.props
    let updatedActiveProfile = {...activeProfile}
    updatedActiveProfile.subscribed = true

    this.props.updateActiveProfile(user, activeProfile.username, updatedActiveProfile)
    .then(() => {
      let updatedUser = {
        ...this.props.user,
        paid_content: true
      }

      this.props.updateReduxUser(updatedUser)
      .then (() => {
        this.props.hideModal()
      })
    })
  }

  // Joint Functions
  renderModalContent() {
    const { errorMessage, status } = this.state

    return errorMessage.length === 0
    ? (
      <div className="onboarding-payment-confirmation-modal-content">
        <p>
          Note: Payment is final. After submitting payment, the sport(s) you selected cannot be changed. You can edit all other player profile and account information by logging in once signup is complete.
        </p>
        <div className="confirm-block">
          <p>
            Are you sure you want to continue?
          </p>
          {
            status !== 'submitting' ?
            (
              <div className="confirm-block-actions">
                <a onClick={() => this.handleStripePayment()} className="cta">
                  Yes
                </a>
                <a onClick={() => this.props.hideModal()} className="cta invert">
                  No
                </a>
              </div>
            )
            : (
              <div className="spinner"></div>
            )
          }
        </div>
      </div>
    )
    : (
      <div className="onboarding-payment-confirmation-modal-content">
        <FlashMessage optionalClasses='error'>
          {errorMessage}
        </FlashMessage>
        <a onClick={() => this.props.hideModal()} className="cta full-width">
          Okay
        </a>
      </div>
    )
  }

  render() {
    return (
      <ModalContainer
        modalExit={false}
        optionalClasses="onboarding-payment-confirmation-modal"
      >
        <header>
          <h2>
            Payment Confirmation
          </h2>
        </header>
        {this.renderModalContent()}
      </ModalContainer>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    onboarding: state.onboarding,
    activeProfile: state.activeProfile
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideModal: modalType => {
      dispatch(hideModal())
    },
    updateReduxUser: (user) => dispatch(updateUserState(user)),
    updateOnboardingForm: formData => {
      dispatch(updateForm(formData))
    },
    updateActiveProfile: (user, username, profile) => dispatch(updateActiveProfile(user, username, profile)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StripePaymentConfirmationModal)



// WEBPACK FOOTER //
// ./src/components/Modals/Payment/StripePaymentConfirmationModal.js